import { HtmlTemplates } from 'utils/html-templates';

var loader = {

    settings: {
        loaderText: '<h3>Loading...</h3>',
        loaderType: 'fullpage',
        autoHide: false,
        autoHideDelay: 2500,
        autoHideDuration: 500,
        domNode: document.body
    },

    eventParams: {},

    // availableTypes:
    // dialog --> position fixed on screen with offsetTop referred to domNode param',
    // fullpage --> position fixed fullpage at end of body',
    // static-dialog --> position static on screen prepended domNode param',
    // xx-small , small ...medium .. large x-large ecc ---> position absolute appendend into domNode
    availableVariantTypes: ['success','loaded','error'],

    getTemplate() {

        const { loaderText , loaderType } = this.settings;

        return HtmlTemplates.loader({ loaderType , loaderText });
    },

    isAlreadyApplied() {

        const { domNode } = this.eventParams;

        const domNodeChilds = Array.prototype.slice.call(domNode.children, 0).filter( childNode => {
            return ( childNode.dataset.componentName !== undefined && childNode.dataset.componentName === "loader" );
        });
        //applico loader...

        return domNodeChilds.length ? true : false;
    },

    apply(e) {

        if(this.settings.loaderType === 'fullpage' && this.settings.domNode !== document.body) {
            //fullpage loader: domNode selector forced to document.body
            this.settings.domNode = document.body;
        }

        this.eventParams = {
            ...this.settings,
            ...e.detail
        };

        const loaderTypeVariant = e.type.split('::');


        let { loaderText , loaderType , domNode , autoHide } = this.eventParams;

        //applico eventuale variante al tipo di loader... .se è prevista in [availableVariantTypes]
        loaderType += (loaderTypeVariant.length && this.availableVariantTypes.includes(loaderTypeVariant[1]) ) ? ('--'+loaderTypeVariant[1]) : '';

        //check presenza del loader -> se si o lo cancello o lo sovrascrivo ... se no lo aggiungo
        if(this.isAlreadyApplied()) {
            this.destroy(e);
        }

        //applico loader...
        domNode.insertAdjacentHTML('beforeend', HtmlTemplates.loader({ loaderType , loaderText }));

        //comounico che l'ho applicato
        this.notify('loader::applied' , e.detail);

        //set timer with autoHide === true
        if(autoHide === true) {
            this.setAutoHide();
        }
    },

    setAutoHide(e) {

        const loaderComponentWrapper = this.eventParams.domNode.querySelector('[data-component-name="loader"]');

        loaderComponentWrapper.addEventListener("animationend", this.destroy , false);
        loaderComponentWrapper.style.animationDelay = `${this.eventParams.autoHideDelay}ms`;
        loaderComponentWrapper.style.animationDuration = `${this.eventParams.autoHideDuration}ms`;
        loaderComponentWrapper.classList.add('autoHide');
    },

    unsetAutoHide(e) {

        const loaderComponentWrapper = this.eventParams.domNode.querySelector('[data-component-name="loader"]');

        //distruggo listener animation end ---che non serve piu
        loaderComponentWrapper.removeEventListener("animationend", this.destroy);
    },

    destroyLandingLoader() {

        const landingLoader = document.getElementById('loader--landing');
        if(landingLoader !== null) {
            //comunico che l'ho distrutto . se l'if fallisce potrebbe essere una casistica di autoHide + show "multipli" di loader nello stesso domNode
            landingLoader.remove();
            this.notify('loader::landing::destroyed' , { landingLoader });
        }
    },

    destroy(e) {

        if(e.type !== 'animationend') {

            this.eventParams = {
                ...this.settings,
                ...e.detail
            };

        }

        const { domNode , autoHide } = this.eventParams;


        if(autoHide === true) {
            this.unsetAutoHide(e);
        }
        if(domNode.querySelector('[data-component-name="loader"]') !== null) {
            //comunico che l'ho distrutto . se l'if fallisce potrebbe essere una casistica di autoHide + show "multipli" di loader nello stesso domNode
            domNode.querySelector('[data-component-name="loader"]').remove();
            this.notify('loader::destroyed' , e.detail);
        }

    },

    notify( eventName , paramsToNotify = { }) {

        this.eventParams = {
            ...this.settings,
            ...paramsToNotify
        };

        const event = new CustomEvent( eventName , { detail: this.eventParams } );
        document.dispatchEvent(event);
        console.log(eventName);

    },

    setListeners() {

        document.addEventListener('loader::apply', this.apply , false);
        document.addEventListener('loader::error', this.apply , false);
        document.addEventListener('loader::success', this.apply , false);
        document.addEventListener('loader::destroy', this.destroy , false);
        document.addEventListener('DOMContentLoaded', this.destroyLandingLoader , false);
    },

    init() {

        this.apply = this.apply.bind(this);
        this.destroyLandingLoader = this.destroyLandingLoader.bind(this);
        this.destroy = this.destroy.bind(this);

        this.setListeners();
        this.notify('loader::ready');
    }
};

export default loader;


// WEBPACK FOOTER //
// ./cpanel/js/components/loader/modules/loaderObserver-functions.js